// NATIVE 
import { useEffect, useState } from 'react';


// INSTALLED 
import { Form } from 'formik';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import {  useDispatch, useSelector } from 'react-redux';
import { Button, Card, CardActionArea, CardMedia, Divider, Grid } from '@mui/material';



// CUSTOM 
import { getImageStore } from '../../store/files';
import editSucursalFormModel from './formModels/edit/editSucursalFormModel';
import { CardActionImage } from '../CardActionImage';





/**
 * DetailSucursalEmpresa component displays the details of a specific branch (sucursal) in a read-only form.
 * It fetches the branch details from the Redux store and navigates to the branch list if no branch is selected.
 * 
 * @param {any} props - The properties passed to the component.
 * 
 * @returns {JSX.Element} The JSX element representing the branch details form.
 * 
 * @remarks
 * - Uses `useNavigate` from `react-router-dom` for navigation.
 * - Uses `useSelector` from `react-redux` to access the branch details from the Redux store.
 * - Contains multiple `TextField` components to display branch details in a read-only mode.
 * - Contains conditional rendering to display the branch logo if available.
 * - Contains multiple `useEffect` hooks to handle navigation based on the branch details.
 */
export const DetailSucursalEmpresa = (props:any) => {



   // CONST FUNCTION 
   const dispatch = useDispatch();


   // NAVIGATION
    const navigate = useNavigate();

  // REDUX
  const { sucursal }:any  = useSelector( (state:any) => state.sucursales );


  //  USE STATE 
  const [logoUrlSucursal, setLogoUrlSucursal] = useState('');

  // DATA FORM MODELS
  const { formId, formField } = editSucursalFormModel;


  


  useEffect(() => {
        
    if ( !sucursal || Object.keys(sucursal).length == 0 ) {
          navigate("/configuracion/sucursales");
    }

  }, [sucursal]);


  useEffect(() => {
      
    if ( !sucursal || Object.keys(sucursal).length == 0 ) {
        navigate("/configuracion/sucursales");
    }

  }, []);


  

  



return (
  <Box sx={{ width: '100%' }}>
   
      
      {
          sucursal &&  Object.keys(sucursal).length > 0 && 
              <Card style={{ marginTop: 50,  padding: 20}}>

                  <Grid container spacing={2}>

                    {/* GRID 9 COLUMNAS  */}
                    <Grid size={{ xs: 9 }}>


                    <Grid container spacing={2} style={{ marginTop: 15 }}>
                      <Grid size={{ xs: 4 }}>
                          <TextField 
                              name={sucursal.name}
                              label={'Nombre'}
                              defaultValue={sucursal.name}
                              variant="outlined" 
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                          />
                      </Grid>
                      <Grid size={{ xs: 4 }}>
                          <TextField 
                              name={sucursal.address}
                              label={'Direccion'}
                              defaultValue={sucursal.address}
                              variant="outlined" 
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                          />
                      </Grid>
                      <Grid size={{ xs: 4 }}>
                          <TextField 
                              name={sucursal.workplace.label}
                              label={'Sitio de trabajo'}
                              defaultValue={sucursal.workplace.label}
                              variant="outlined" 
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                          />
                      </Grid>
                    </Grid>

                    <Grid container spacing={2} style={{ marginTop: 15 }}>
                      <Grid size={{ xs: 4 }}>
                          <TextField 
                              name={sucursal.country.label}
                              label={'Pais'}
                              defaultValue={sucursal.country.label}
                              variant="outlined" 
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                          />
                      </Grid>
                      <Grid size={{ xs: 4 }}>
                          <TextField 
                              name={sucursal.departament.label}
                              label={'Departamento'}
                              defaultValue={sucursal.departament.label}
                              variant="outlined" 
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                          />
                      </Grid>
                      <Grid size={{ xs: 4 }}> 
                          <TextField 
                              name={sucursal.municipaly.label}
                              label={'Municipio'}
                              defaultValue={sucursal.municipaly.label}
                              variant="outlined" 
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                          />
                      </Grid>
                    </Grid> 

                   <Grid container spacing={2} style={{ marginTop: 15 }}>
                      <Grid size={{ xs: 4 }}>
                      <TextField 
                              name={sucursal.family_compensation_fund?.label || "N/A" }
                              label={'Caja Compensacion'}
                              defaultValue={sucursal.family_compensation_fund.label || "N/A" }
                              variant="outlined" 
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                          />
                        
                      </Grid>
                      <Grid size={{ xs: 4 }}>
                          <TextField 
                              name={sucursal.landline}
                              label={'Telefono Fijo'}
                              defaultValue={sucursal.landline}
                              variant="outlined" 
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                          />
                      </Grid>
                      <Grid size={{ xs: 4 }}>
                        <TextField 
                              name={sucursal.cell_phone}
                              label={'Celular'}
                              defaultValue={sucursal.cell_phone}
                              variant="outlined" 
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                          />
                      </Grid>
                  </Grid> 
                  <Grid container spacing={2} style={{ marginTop: 15 }}>
                      <Grid size={{ xs: 3 }}>
                          <TextField 
                              name={sucursal.arl.label}
                              label={'Arl'}
                              defaultValue={sucursal.arl.label}
                              variant="outlined" 
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                          />
                      </Grid>
                      <Grid size={{ xs: 3 }}>
                          <TextField 
                              name={sucursal.associated_bank.label}
                              label={'Banco asociado'}
                              defaultValue={sucursal.associated_bank.label}
                              variant="outlined" 
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                          />
                      </Grid>
                      <Grid size={{ xs: 3 }}>
                          <TextField 
                              name={sucursal.type_account_bank.label}
                              label={'Tipo Cuenta'}
                              defaultValue={sucursal.type_account_bank.label}
                              variant="outlined" 
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                          />
                      </Grid>
                      <Grid size={{ xs: 3 }}>
                          <TextField 
                              name={sucursal.account_number}
                              label={'Numero Cuenta'}
                              defaultValue={sucursal.account_number}
                              variant="outlined" 
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                          />
                      </Grid>
                  </Grid>

                    </Grid>
                    {/* END GRID 9 COLUMNAS */}


                    {/* GRID 3 COLUMNAS  */}
                    <Grid size={{ xs: 3 }}>

                      <Grid size={{ xs: 12 }}>
                          <Button> Logo Sucursal</Button>
                          <Divider/>
                          
                          {
                            sucursal.logo
                          
                              ?
                                  <>
                                  <CardActionImage urlImage={sucursal.logo} typeImage={'branch'} />
                                  </>
                              :
                              ''
                          }
                      </Grid>
                    </Grid>
                    {/* END GRID 3 COLUMNAS  */}

                  </Grid>
                  
                 
                
                
          </Card>
      }
      
      
  </Box>
)
}